import { render, staticRenderFns } from "./DeleteGray.vue?vue&type=template&id=69a1a773"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69a1a773')) {
      api.createRecord('69a1a773', component.options)
    } else {
      api.reload('69a1a773', component.options)
    }
    module.hot.accept("./DeleteGray.vue?vue&type=template&id=69a1a773", function () {
      api.rerender('69a1a773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/DeleteGray.vue"
export default component.exports